// extracted by mini-css-extract-plugin
export var hidden = "_uy-0";